@if (historieLoading()) {
  <clr-spinner class="centred" />
} @else if (historieTree()) {
  <div class="h-100 w-100-p d-f row">
    <div class="clr-col-auto h-100 scroll-y no-scroll-x padding-0-l">
      <clr-tree>
        @for (historie of historieTree(); track historie.Key) {
          <clr-tree-node>
            <cds-icon [shape]="icons[historie.Key]" />
            {{ historie.Key | mrTranslate | titlecase }}
            @for (node of historie.Value; track $index) {
              <clr-tree-node>
                @if ('date' in node) {
                  @let nodeID = { mode: historie.Key, idOrDate: node.id ?? node.date, info: node.info };
                  <button
                    class="clr-treenode-link"
                    (click)="selectedNode.set(nodeID)"
                    [class.active]="selectedNode() == nodeID">
                    {{ node.date | date }}
                  </button>
                  @if (historie.Key == 'inspektionen' && node.OTYPID == 2) {
                    <button type="button" class="btn btn-sm btn-icon" (click)="getMessungsUebersicht(node)">
                      <cds-icon [title]="'Messung Übersicht' | mrTranslate" size="20" shape="view-cards" />
                    </button>
                  }
                } @else {
                  {{ node.Key }}
                }
                @for (r of 'date' in node ? [] : node.Value; track r.id) {
                  <clr-tree-node [clrExpanded]="false">
                    @let node = { mode: historie.Key, idOrDate: r.id };
                    <button
                      class="clr-treenode-link"
                      (click)="selectedNode.set(node)"
                      [class.active]="selectedNode() == node">
                      {{ r.datum | date }}
                    </button>
                  </clr-tree-node>
                }
              </clr-tree-node>
            }
          </clr-tree-node>
        }
      </clr-tree>
    </div>
    @if (tableLoading()) {
      <clr-spinner class="centred" />
    }
    @if (nodeTable(); as table) {
      @let node = selectedNode();
      @let mode = selectedNode().mode;
      @let tolOptions = tol();
      <div class="clr-col h-100 scroll-y">
        <div #heightRef>
          <app-image-slide-show [data]="files()" />
        </div>
        @if (table?.rows?.length && tolOptions) {
          <clr-datagrid
            class="datagrid-compact dg-history"
            [dymanicStyle]="heightRef"
            addPx="10"
            styleMode="max-height">
            @if (mode == 'inspektionen') {
              <clr-dg-column class="mw-0">{{ 'Log' | mrTranslate }}</clr-dg-column>
            }
            @if (mode | in: ['stoerungen', 'instandsetzungen', 'inspektionen', 'wartungen', 'sonderinspektion']) {
              <clr-dg-column class="mw-0">{{ 'Medien' | mrTranslate }}</clr-dg-column>
            }
            @for (column of table.columns; track column.id) {
              <clr-dg-column [clrDgField]="column.id">
                <ng-container
                  *clrDgHideableColumn="{
                    hidden: column.id | hideIDColumns: ['bilder', 'rueckbilder', 'revbild'],
                  }">
                  @if (mode == 'messungen') {
                    {{ column.id | transformColNames: tolOptions | mrTranslate }}
                  } @else {
                    {{ column.id | titlecase | mrUnitText }}
                  }
                </ng-container>
              </clr-dg-column>
            }

            <clr-dg-row *clrDgItems="let row of table.rows">
              @if (mode == 'inspektionen') {
                <clr-dg-cell class="mw-0">
                  <a href="javascript:void(0)" (click)="mangelLog.set(+row.omazsid)">
                    <cds-icon shape="view-list" size="20" />
                  </a>
                </clr-dg-cell>
              }
              @if (mode | in: ['stoerungen', 'instandsetzungen', 'inspektionen', 'wartungen', 'sonderinspektion']) {
                <clr-dg-cell class="mw-0">
                  <a
                    href="javascript:void(0)"
                    (click)="selectedRow.set(row)"
                    [class.deactivate]="!row.bilder && !row.rueckbilder && !row.RevBild">
                    <cds-icon
                      [shape]="!row.bilder && !row.rueckbilder && !row.RevBild ? 'blank' : 'image-gallery'"
                      size="20" />
                  </a>
                </clr-dg-cell>
              }
              @for (cell of table.columns; track cell.id) {
                @if (mode == 'messungen' && cell.id == 'Tol-Verl.') {
                  <clr-dg-cell class="noover">
                    @if (row[cell.id]; as ausfall) {
                      <span
                        class="label ausfall"
                        [style.--ausfall-color]="ausfall.toString() | getAusfallColor: tolOptions">
                        {{ ausfall }}
                      </span>
                    }
                  </clr-dg-cell>
                } @else {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                }
              }
            </clr-dg-row>
            <clr-dg-footer>{{ table.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        } @else {
          <div class="margin-3-t">{{ 'keine Daten vorhanden' | mrTranslate }}</div>
        }
        @if (mode == 'inspektionen' && 'info' in node) {
          <br/>
          <div class="margin-3-t">{{ 'Bemerkung zur Prüfung' | mrTranslate }}:</div>
          <textarea id="textarea-basic" class="clr-textarea" readonly="true">{{ node.info }}</textarea>        
        }
      </div>
    }

  </div>
}

@if (mangelLog()) {
  <app-mangel-log-modal [(omazsid)]="mangelLog" />
}

<app-mediaviewmodal
  (onClose)="selectedRow.set(null)"
  [srcs]="mediaViewInfo()?.sources"
  [getMediaFromServerAll]="mediaViewInfo()?.getApiFunctionMedia"
  [getBigFileFnc]="mediaViewInfo()?.getApiFunctionMediaBig" />
